module.exports = __webpack_public_path__ + "static/media/logo.77bb1c21.png";